import styles from './index.module.scss'
import { CloseCircleOutlined } from '@ant-design/icons'
import { Radio, Space } from 'antd'
import { toSentenceCase } from "../../../utils/utils";

interface ModalityListProps {
    evt: Digital_Protocol_SoA_Table_Data.Entity
    idx: number,
    value: string
    onModalityChange: (e, evt:Digital_Protocol_SoA_Table_Data.Entity, id: number) => void,
    modalityOptions: Digital_Protocol_SoA_Table_Data.ModalityOption[]
}
export function ModalityList({
    evt, 
    idx,
    value,
    onModalityChange,
    modalityOptions
  }: ModalityListProps) {

    
    return (
        <div className={styles.modalityListContainer}>
             <CloseCircleOutlined />
             <Radio.Group 
                value={Number(value)}
                onChange={(e)=>onModalityChange(e,evt,idx)}
                className="dct-radio-group"
                key={`radio-group-${idx}}`} >
                <Space direction="vertical">
                    <div className={styles.modalityItem} key={idx}>
                        {modalityOptions.map( (m,indx)=>{
                            return (
                            <Radio
                                value={m.key}
                                disabled={evt?.modality&&evt.modality[indx]==0?true:false}
                                key={`radio-${indx}`}  >
                                <img 
                                    src={m.icon} alt="" 
                                    style ={{ backgroundColor: m.color, 
                                    borderRadius: '50%',
                                    marginRight: m.name !== "Clear" ? '2px' : '0px',
                                    display: 'inline-block'
                                }}/> 
                                {m.name.length > 0 ? (m.name === "eConsent" ? "eConsent"  : toSentenceCase(m.name)) : "Clear"} 
                            </Radio>
                            )
                        })}
                    </div>
                </Space>
             </Radio.Group>
        </div>
    )

  }